<template>
    <base-section
    :id="title"
    >
    <base-section-heading :title="title">
    It will take place at <strong>{{ room }}, {{ date }}</strong>.
    <br>
    Moderator of this session is {{ moderators }}.
    </base-section-heading>
    <base-section-heading title="Abstract">
    {{ abstract }}
    </base-section-heading>
    <base-section-heading title="Bio">
    <strong>Speaker: {{ speaker }}</strong>
    <br>
    <br>
    <v-row
    justify="center"
    >
    <v-img
      max-width="200"
      :src="image"
      aspect-ratio="1"
      >
    </v-img>
    </v-row>
    <br>
    {{ bio }}
    </base-section-heading>
  </base-section>
</template>

<script>
  export default {
    name: 'Keynote',

    props: {
        title: String,
        moderator: String,
        abstract: String,
        bio: String,
        website: String,
        image: String,
        speaker: String,
        room: String,
        moderators: String,
        date: String,
    },

  }
</script>
